import { useState, useEffect } from "react";

// Material Dashboard 2 PRO React contexts
import { useMaterialUIController } from "context";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";

import MDBox from "../../../components/MDBox";
import MDModal from "../../../components/MDModal";
import MDTypography from "../../../components/MDTypography";
import MDButton from "../../../components/MDButton";
import moment from "moment";

import { getDevice, putDevice } from "../../../api/devices";

import { getOrder } from "../../../api/orders";

import PropTypes from "prop-types";

import { useDispatch, useSelector } from "react-redux";

import { setCurrentDevices } from "../../../redux/reducers/devicesReducer";

import { setCurrentOrder } from "../../../redux/reducers/ordersReducer";
import Mad from "./Mad";

export default function EditMad({ device = null, edit = false }) {
  const [open, setOpen] = useState(false);

  const [deviceId, setDeviceId] = useState("");
  const [madSentDate, setMadSentDate] = useState(null);

  const currentOrder = useSelector((state) => state.orders.currentOrder);

  const dispatch = useDispatch();

  useEffect(() => {
    if (edit && device) {
      setDeviceId(device.device_id);
      setMadSentDate(device.mad_sent_date);
    }
  }, [edit, device]);

  async function updateDeviceAPI() {
    const device = {
      mad_sent_date: madSentDate ? moment(madSentDate).format("YYYY-MM-DD") : null,
    };
    await putDevice(device, deviceId);
  }

  async function fetchOrder() {
    const response = await getOrder(currentOrder.order_id);
    dispatch(setCurrentOrder(response.data));
  }

  async function fetchDevice(deviceId) {
    const response = await getDevice(deviceId);
    return await response.data;
  }

  const fetchDevices = async () => {
    if (currentOrder) {
      if (currentOrder.devices_ids) {
        const devices = [];
        const devices_id = currentOrder.devices_ids.split(",");
        for (let i = 0; i < devices_id.length; i++) {
          devices.push(await fetchDevice(devices_id[i]));
        }

        // Sort the devices array based on the device identifier
        devices.sort((a, b) => {
          // Extract the base device identifier (ignoring anything after a hyphen)
          const baseIdA = a.device_number.split(" -")[0];
          const baseIdB = b.device_number.split(" -")[0];

          // Compare the base identifiers
          if (baseIdA < baseIdB) return -1;
          if (baseIdA > baseIdB) return 1;

          // If base identifiers are equal, compare the full device_id to maintain relative order
          return a.device_number.localeCompare(b.device_number);
        });

        dispatch(setCurrentDevices(devices));
      }
    }
  };

  async function cancel() {
    fetchOrder();
    setOpen(false);
  }

  async function submit() {
    if (edit) {
      await updateDeviceAPI();
      await fetchOrder();
      await fetchDevices();
    }
    setOpen(false);
  }

  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  return (
    <>
      {edit ? (
        <IconButton size="medium" disableRipple color="inherit" onClick={() => setOpen(true)}>
          <Icon style={{ color: darkMode ? "#344767" : "#FFF" }}>edit</Icon>
        </IconButton>
      ) : (
        <IconButton size="medium" disableRipple color="inherit" onClick={() => setOpen(true)}>
          <Icon style={{ color: darkMode ? "#344767" : "#FFF" }}>add</Icon>
        </IconButton>
      )}
      <MDModal open={open} onClose={() => setOpen(false)}>
        <MDBox mt={25} mb={9}>
          <Grid container justifyContent="center">
            <Grid item xs={12} lg={8}>
              <Card>
                <MDBox
                  mt={-5}
                  mb={2}
                  mx={2}
                  variant="gradient"
                  sx={{
                    background: darkMode ? "white" : "linear-gradient(195deg, #364c70, #273956)",
                    boxShadow: darkMode ? "0 1px 6px 1px white" : "0 1px 6px 1px #344767",
                  }}
                  borderRadius="lg"
                  textAlign="center"
                >
                  <MDBox mt={2} mb={2}>
                    <MDBox>
                      <MDTypography
                        variant="h3"
                        fontWeight="bold"
                        color={darkMode ? "inherit" : "white"}
                      >
                        Modification du MAD
                      </MDTypography>
                    </MDBox>
                    <MDTypography
                      variant="h5"
                      fontWeight="regular"
                      color={darkMode ? "inherit" : "white"}
                    >
                      Veuillez remplir les informations demandées
                    </MDTypography>
                  </MDBox>
                </MDBox>
                <MDBox p={2}>
                  <MDBox>
                    <Mad
                      deviceId={deviceId}
                      madSentDate={madSentDate}
                      setMadSentDate={setMadSentDate}
                    />
                    <MDBox mt={3} width="100%" display="flex" justifyContent="space-between">
                      <MDBox sx={{ width: "1px" }} />
                      <MDBox textAlign="right">
                        <Grid container spacing={1.5}>
                          <Grid item>
                            <MDButton variant="gradient" color="warning" onClick={cancel}>
                              Annuler
                            </MDButton>
                          </Grid>
                          <Grid item>
                            <MDButton variant="gradient" color="success" onClick={submit}>
                              {"Envoyer"}
                            </MDButton>
                          </Grid>
                        </Grid>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
      </MDModal>
    </>
  );
}

EditMad.propTypes = {
  edit: PropTypes.bool.isRequired,
};